export const EventHubLogActions = {
	updated: 'updated',
	created: 'created',
	deleted: 'deleted',
	voided: 'voided',
	failed: 'failed',
	refunded: 'refunded',
};
